/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/ban-types */
import '../_debug_hook';
import type { Disposer } from '@visiba/std';
import { FixedSizeImpl } from '../data_struct/fixed_size_impl';
import { PRESENTATION_DEBUG_REF } from './common';

/**
 * ## cortex:presentation:SynchronousPresentation
 *
 * @public
 * @deprecated Use React state/context and custom hooks for local UI state instead.
 */
export class SynchronousPresentation<T extends object> {
	private readonly data: FixedSizeImpl<T>;
	private readonly hooks: Map<symbol, (changeSet?: Set<keyof T>) => void> = new Map();

	constructor(initialValue: T) {
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		if (globalThis[PRESENTATION_DEBUG_REF]) {
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			//@ts-ignore
			globalThis[PRESENTATION_DEBUG_REF].add(this);
		}

		if (typeof initialValue !== 'object') {
			throw new Error('a state can only be represented as an object literal');
		}

		this.data = new FixedSizeImpl(initialValue);
	}

	public subscribe(event: (changeSet?: Set<keyof T>) => void): Disposer {
		const id = Symbol();

		this.hooks.set(id, event);

		return () => {
			this.hooks.delete(id);
		};
	}

	public write(currentState: Partial<T> | ((currentState: Readonly<Omit<FixedSizeImpl<T>, 'insert'>>) => Partial<T>)): void {
		try {
			const newState = currentState instanceof Function ? currentState(this.data) : currentState;

			const changeSet = this.data.insert(newState);
			this.dispatch(changeSet);
		} catch (error) {
			console.error(`could not mutate the state:\n\n${error}`);
		}
	}

	public read(): Readonly<T> {
		return this.data.extract();
	}

	private dispatch(changeSet?: Set<keyof T>): void {
		this.hooks.forEach((hook) => hook(changeSet));
	}
}
